import { useState, type FormEvent } from 'react';
import Icon from '@/components/ui/Icon/Icon';
import styles from './AddressSearchBar.module.css';

type Props = {
  initialValue?: string;
  loading?: boolean;
  error?: string | null;
  onSubmit: (query: string) => void;
};

export default function AddressSearchBar({
  initialValue = '',
  loading = false,
  error,
  onSubmit,
}: Props) {
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit} role="search">
      <label htmlFor="address-input" className={styles.label}>
        住所・地名を入力
      </label>
      <div className={styles.bar}>
        <Icon name="map-pin" size={20} color="var(--color-text-sub)" />
        <input
          id="address-input"
          type="text"
          className={styles.input}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="例: 東京都千代田区丸の内 1 丁目"
          autoComplete="off"
          disabled={loading}
        />
        <button
          type="submit"
          className={styles.submit}
          disabled={loading || !value.trim()}
        >
          {loading ? (
            <span className={styles.spinner} aria-label="検索中" />
          ) : (
            <>
              <Icon name="search" size={18} />
              <span>調べる</span>
            </>
          )}
        </button>
      </div>
      {error && (
        <div className={styles.error} role="alert">
          {error}
        </div>
      )}
      <p className={styles.hint}>
        地図をクリックしても、その場所のレポートが表示されます。
      </p>
    </form>
  );
}
